module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-01-868424b2fb2333ccf48d2ddf38b96c2e.png";